export const depositAuthPages = [
  {
    path: '/depositAuth/depositMoney',
    name: 'depositMoney',
    component: () => import('views/depositAuth/depositMoney/index'),
    meta: {
      title: '收押金'
    }
  },
  {
    path: '/depositAuth/depositResult',
    name: 'depositResult',
    component: () => import('views/depositAuth/depositResult/index'),
    meta: {
      title: '收款'
    }
  },
  {
    path: '/depositAuth/depositBillList',
    name: 'depositBillList',
    component: () => import('views/depositAuth/depositBillList/index'),
    meta: {
      title: '押金账单'
    }
  },
  {
    path: '/depositAuth/depositFilterBillList',
    name: 'depositFilterBillList',
    component: () => import('views/depositAuth/depositBillList/index'),
    meta: {
      title: '筛选结果'
    }
  },
  {
    path: '/depositAuth/depositFilter',
    name: 'depositFilter',
    component: () => import('views/depositAuth/depositFilter/index'),
    meta: {
      title: '筛选'
    }
  }
]
